export const shopProducts = [
  {
    id: 'hoodie-001',
    name: 'RE:SET Hoodie',
    category: 'Apparel',
    price: 65,
    image: 'https://public.readdy.ai/ai/img_res/8486928a0bdf9b49a1d4acca10436cfc.jpg',
    stock: 'In stock',
    stockCount: 45,
    description: 'Crafted from organic cotton for all-day comfort. A quiet essential for mindful living.',
    variants: [
      { id: 'hoodie-s', size: 'S', price: 65, stock: 12 },
      { id: 'hoodie-m', size: 'M', price: 65, stock: 15 },
      { id: 'hoodie-l', size: 'L', price: 65, stock: 10 },
      { id: 'hoodie-xl', size: 'XL', price: 65, stock: 8 }
    ]
  },
  {
    id: 'cap-001',
    name: 'RE:SET Cap',
    category: 'Accessories',
    price: 28,
    image: 'https://readdy.ai/api/search-image?query=minimalist%20premium%20baseball%20cap%20in%20soft%20sand%20beige%20color%20with%20subtle%20embroidered%20logo%20on%20clean%20white%20background%20with%20natural%20lighting%20showcasing%20quality%20fabric%20texture%20and%20structured%20design%20for%20wellness%20lifestyle%20brand&width=800&height=1000&seq=cap001&orientation=portrait',
    stock: 'In stock',
    stockCount: 32,
    description: 'Understated design with an adjustable fit. One size, endless ease.',
    variants: [
      { id: 'cap-onesize', size: 'One Size', price: 28, stock: 32 }
    ]
  },
  {
    id: 'bottle-001',
    name: 'RE:SET Water Bottle',
    category: 'Drinkware',
    price: 32,
    image: 'https://readdy.ai/api/search-image?query=elegant%20stainless%20steel%20reusable%20water%20bottle%20in%20matte%20sage%20green%20color%20on%20minimal%20white%20surface%20with%20soft%20natural%20lighting%20and%20clean%20shadows%20showcasing%20sleek%20cylindrical%20design%20and%20premium%20finish%20for%20wellness%20lifestyle%20brand&width=800&height=1000&seq=bottle001&orientation=portrait',
    stock: 'Low stock',
    stockCount: 8,
    description: 'Stainless steel. Reusable. Designed to keep you hydrated through every reset.',
    variants: [
      { id: 'bottle-onesize', size: 'One Size', price: 32, stock: 8 }
    ]
  },
  {
    id: 'keyring-001',
    name: 'RE:SET Keyring',
    category: 'Accessories',
    price: 15,
    image: 'https://readdy.ai/api/search-image?query=minimal%20premium%20metal%20keyring%20with%20subtle%20rubber%20accent%20in%20warm%20beige%20tone%20on%20clean%20white%20surface%20with%20soft%20lighting%20showcasing%20sleek%20modern%20design%20and%20quality%20craftsmanship%20for%20wellness%20lifestyle%20brand&width=800&height=1000&seq=keyring001&orientation=portrait',
    stock: 'In stock',
    stockCount: 50,
    description: 'A small reminder to pause. Minimal metal with a soft rubber accent.',
    variants: [
      { id: 'keyring-onesize', size: 'One Size', price: 15, stock: 50 }
    ]
  },
  {
    id: 'tshirt-001',
    name: 'RE:SET T-Shirt',
    category: 'Apparel',
    price: 38,
    image: 'https://readdy.ai/api/search-image?query=premium%20organic%20cotton%20t-shirt%20in%20soft%20warm%20sand%20color%20laid%20flat%20on%20white%20surface%20with%20natural%20lighting%20showcasing%20relaxed%20fit%20and%20quality%20fabric%20texture%20for%20wellness%20lifestyle%20brand&width=800&height=1000&seq=tshirt001&orientation=portrait',
    stock: 'In stock',
    stockCount: 38,
    description: 'Soft organic cotton. Effortless comfort for everyday restoration.',
    variants: [
      { id: 'tshirt-s', size: 'S', price: 38, stock: 10 },
      { id: 'tshirt-m', size: 'M', price: 38, stock: 12 },
      { id: 'tshirt-l', size: 'L', price: 38, stock: 10 },
      { id: 'tshirt-xl', size: 'XL', price: 38, stock: 6 }
    ]
  },
  {
    id: 'tote-001',
    name: 'RE:SET Tote Bag',
    category: 'Accessories',
    price: 22,
    image: 'https://readdy.ai/api/search-image?query=minimal%20canvas%20tote%20bag%20in%20natural%20cream%20color%20with%20subtle%20branding%20on%20clean%20white%20background%20with%20soft%20lighting%20showcasing%20quality%20fabric%20and%20spacious%20design%20for%20wellness%20lifestyle%20brand&width=800&height=1000&seq=tote001&orientation=portrait',
    stock: 'In stock',
    stockCount: 28,
    description: 'Durable canvas for carrying your essentials. Thoughtfully made, endlessly useful.',
    variants: [
      { id: 'tote-onesize', size: 'One Size', price: 22, stock: 28 }
    ]
  }
];
